exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-2c2b0012] .el-form-item {\n  margin: -4px 0 0;\n}\n", ""]);

// exports
